// appshell host used for local development to redirect requests
export const APPSHELL_LOCAL_DEV_HOST = "https://www.tst.skistar.com"

export const DATE_SEARCH_PARAM_NAME = "date"
export const CATEGORY_SEARCH_PARAM_NAME = "category"
export const STEP_SEARCH_PARAM_NAME = "step"
export const PARTNER_CODE_SEARCH_PARAM_NAME = "code"
export const LENGTH_SEARCH_PARAM_NAME = "length"
export const CART_ITEM_ID_SEARCH_PARAM_NAME = "cartItemId"

/**
 * Mapping of friendly param names to actual URL search parameter names.
 * Single source of truth for URL parameter configuration.
 */
export const URL_PARAM_NAME_MAP = {
  step: STEP_SEARCH_PARAM_NAME,
  category: CATEGORY_SEARCH_PARAM_NAME,
  date: DATE_SEARCH_PARAM_NAME,
  length: LENGTH_SEARCH_PARAM_NAME,
  cartItemId: CART_ITEM_ID_SEARCH_PARAM_NAME,
} as const
